const jhscreativeArtsAndDesignQuestions = [
  {
    question: "Which element of art refers to the surface quality of an object that can be seen or felt?",
    options: [
      "Texture",
      "Form",
      "Shape",
      "Space"
    ],
    answer: "Texture"
  },
  {
    question: "What type of balance is achieved when both sides of an artwork are identical?",
    options: [
      "Asymmetrical balance",
      "Radial balance",
      "Symmetrical balance",
      "Visual balance"
    ],
    answer: "Symmetrical balance"
  },
  {
    question: "Which color scheme consists of colors next to each other on the color wheel?",
    options: [
      "Complementary",
      "Analogous",
      "Monochromatic",
      "Triadic"
    ],
    answer: "Analogous"
  },
  {
    question: "Which musical dynamic marking indicates the music should be played softly?",
    options: [
      "Forte",
      "Piano",
      "Allegro",
      "Crescendo"
    ],
    answer: "Piano"
  },
  {
    question: "What is the process of making a rough draft or early model of a design called?",
    options: [
      "Weaving",
      "Prototyping",
      "Casting",
      "Etching"
    ],
    answer: "Prototyping"
  },
  {
    question: "What do we call the repeated use of lines, colors, or shapes in a pattern?",
    options: [
      "Balance",
      "Rhythm",
      "Contrast",
      "Unity"
    ],
    answer: "Rhythm"
  },
  {
    question: "Which technique involves shaping a material by pouring it into a mold?",
    options: [
      "Folding",
      "Casting",
      "Cutting",
      "Welding"
    ],
    answer: "Casting"
  },
  {
    question: "Which of the following is a soft modeling material often used in sculpture?",
    options: [
      "Charcoal",
      "Chalk",
      "Clay",
      "Glue"
    ],
    answer: "Clay"
  },
  {
    question: "What is the name for a short theatrical performance based on a social issue?",
    options: [
      "Mime",
      "Dance drama",
      "Monologue",
      "Improv sketch"
    ],
    answer: "Dance drama"
  },
  {
    question: "What is the main focus of harmony in music?",
    options: [
      "Creating loud beats",
      "Blending different notes played together",
      "Speeding up tempo",
      "Writing lyrics"
    ],
    answer: "Blending different notes played together"
  },
  {
    question: "Which printing technique uses carved materials like linoleum or wood?",
    options: [
      "Screen printing",
      "Relief printing",
      "Digital printing",
      "Laser printing"
    ],
    answer: "Relief printing"
  },
  {
    question: "In visual art, what does the term 'medium' refer to?",
    options: [
      "The size of the artwork",
      "The color used",
      "The material used to make the artwork",
      "The location of the exhibition"
    ],
    answer: "The material used to make the artwork"
  },
  {
    question: "Which of these is NOT typically considered a principle of design?",
    options: [
      "Movement",
      "Proportion",
      "Contrast",
      "Volume"
    ],
    answer: "Volume"
  },
  {
    question: "Which term refers to a sequence of steps followed during the design process?",
    options: [
      "Design cycle",
      "Design flow",
      "Design formula",
      "Design method"
    ],
    answer: "Design cycle"
  },
  {
    question: "Which art form combines movement, expression, and rhythm without words?",
    options: [
      "Painting",
      "Mime",
      "Sketching",
      "Casting"
    ],
    answer: "Mime"
  },
  {
    question: "Which colors are considered primary colors in art?",
    options: [
      "Red, Green, Blue",
      "Red, Yellow, Blue",
      "Orange, Green, Purple",
      "Blue, White, Black"
    ],
    answer: "Red, Yellow, Blue"
  },
  {
    question: "What is used to describe the loudness or softness in a musical piece?",
    options: [
      "Tempo",
      "Pitch",
      "Dynamics",
      "Melody"
    ],
    answer: "Dynamics"
  },
  {
    question: "Which of the following refers to the use of opposite elements to create interest?",
    options: [
      "Harmony",
      "Contrast",
      "Unity",
      "Repetition"
    ],
    answer: "Contrast"
  },
  {
    question: "Which of these is a common time signature in music?",
    options: [
      "5/5",
      "3/4",
      "8/9",
      "10/6"
    ],
    answer: "3/4"
  },
  {
    question: "Which material is commonly used for paper mâché modeling?",
    options: [
      "Fabric and glue",
      "Clay and sand",
      "Shredded paper and paste",
      "Wax and chalk"
    ],
    answer: "Shredded paper and paste"
  },
  {
    question: "What skill is developed when learners reflect and revise their creative works?",
    options: [
      "Copying",
      "Repetition",
      "Critical thinking",
      "Memorization"
    ],
    answer: "Critical thinking"
  },
  {
    question: "What is the purpose of using shading in drawing?",
    options: [
      "To make it colorful",
      "To create depth and form",
      "To confuse the viewer",
      "To outline clearly"
    ],
    answer: "To create depth and form"
  },
  {
    question: "Which of the following is a structural component of dance?",
    options: [
      "Harmony",
      "Costume",
      "Choreography",
      "Instrument"
    ],
    answer: "Choreography"
  },
  {
    question: "What is the role of a conductor in music performance?",
    options: [
      "To write lyrics",
      "To perform solos",
      "To lead the group and control tempo",
      "To dance"
    ],
    answer: "To lead the group and control tempo"
  },
  {
    question: "What term is used for the plan or arrangement of elements in artwork?",
    options: [
      "Design",
      "Theme",
      "Mood",
      "Genre"
    ],
    answer: "Design"
  },
  {
    question: "Which tool would be most suitable for detailed sketching?",
    options: [
      "Charcoal",
      "Ruler",
      "HB Pencil",
      "Eraser"
    ],
    answer: "HB Pencil"
  },
  {
    question: "Which of these is an example of a musical texture?",
    options: [
      "Loud",
      "Fast",
      "Thick",
      "Bright"
    ],
    answer: "Thick"
  },
  {
    question: "What is the purpose of warm-up exercises before a dance performance?",
    options: [
      "To pass time",
      "To prevent injuries",
      "To practice rhythm",
      "To impress the audience"
    ],
    answer: "To prevent injuries"
  },
  {
    question: "What does improvisation mean in performance arts?",
    options: [
      "Following a script strictly",
      "Copying someone’s performance",
      "Creating spontaneously",
      "Reading stage directions"
    ],
    answer: "Creating spontaneously"
  },
  {
    question: "Which color combination creates green?",
    options: [
      "Red and blue",
      "Blue and yellow",
      "Red and yellow",
      "Black and white"
    ],
    answer: "Blue and yellow"
  },
  {
    question: "Which of these is a recyclable material used in creative modeling?",
    options: [
      "Plastic bottles",
      "Chalk dust",
      "Foam cups",
      "Fabric glue"
    ],
    answer: "Plastic bottles"
  },
  {
    question: "What is the main aim of exhibiting student artworks?",
    options: [
      "To decorate the walls",
      "To practice writing",
      "To showcase creativity and receive feedback",
      "To prepare for exams"
    ],
    answer: "To showcase creativity and receive feedback"
  },
  {
    question: "In music, which term refers to the speed of the beat?",
    options: [
      "Pitch",
      "Rhythm",
      "Tempo",
      "Tone"
    ],
    answer: "Tempo"
  },
  {
    question: "What is a collage?",
    options: [
      "A type of dance",
      "A clay sculpture",
      "An artwork made by sticking different materials onto a surface",
      "A musical instrument"
    ],
    answer: "An artwork made by sticking different materials onto a surface"
  },
  {
    question: "Which of the following helps to create mood in a theatrical performance?",
    options: [
      "Lighting and music",
      "Cost of materials",
      "Number of performers",
      "Size of props"
    ],
    answer: "Lighting and music"
  },
  {
    question: "What is the main role of costumes in performance art?",
    options: [
      "To keep performers warm",
      "To identify characters and support the theme",
      "To improve sound quality",
      "To decorate the venue"
    ],
    answer: "To identify characters and support the theme"
  },
  {
    question: "Which of the following instruments is classified as a percussion instrument?",
    options: [
      "Trumpet",
      "Drum",
      "Flute",
      "Violin"
    ],
    answer: "Drum"
  },
  {
    question: "What is a storyboard?",
    options: [
      "A set of lyrics",
      "A sculpture technique",
      "A visual plan for a performance or animation",
      "An actor's script"
    ],
    answer: "A visual plan for a performance or animation"
  },
  {
    question: "Which of these best describes the term 'ensemble' in music?",
    options: [
      "Solo performance",
      "Group of musicians playing together",
      "Silent performance",
      "Drumbeat rhythm"
    ],
    answer: "Group of musicians playing together"
  },
  {
    question: "Why is reflection important after creating an artwork or performance?",
    options: [
      "To criticize others",
      "To improve future work and self-awareness",
      "To make the work longer",
      "To prepare for the next performance only"
    ],
    answer: "To improve future work and self-awareness"
  },
  {
    question: "Which method is used for shaping 3D forms using strips of paper and paste?",
    options: [
      "Carving",
      "Modeling",
      "Paper mâché",
      "Assembling"
    ],
    answer: "Paper mâché"
  },
  {
    question: "What do lines that move in circular directions in a design often show?",
    options: [
      "Movement and rhythm",
      "Stillness",
      "Structure",
      "Silence"
    ],
    answer: "Movement and rhythm"
  },
  {
    question: "Which of the following is used in fabric designing?",
    options: [
      "Embroidery and tie-dye",
      "Pencil sketching",
      "Singing",
      "Paper folding"
    ],
    answer: "Embroidery and tie-dye"
  },
  {
    question: "What is the function of a backdrop in stage performances?",
    options: [
      "To block lights",
      "To create scenery or setting",
      "To hang costumes",
      "To control music"
    ],
    answer: "To create scenery or setting"
  },
  {
    question: "What is the name of a musical composition made up of different chords played together?",
    options: [
      "Scale",
      "Chord progression",
      "Note arrangement",
      "Solo"
    ],
    answer: "Chord progression"
  },
  {
    question: "Which of these tools would best be used to create textures on clay?",
    options: [
      "Spoon",
      "Wire tool",
      "Brush",
      "Crayon"
    ],
    answer: "Wire tool"
  },
  {
    question: "Which of these is a form of traditional African textile design?",
    options: [
      "Kente weaving",
      "Screen printing",
      "Embossing",
      "Watercolor wash"
    ],
    answer: "Kente weaving"
  },
  {
    question: "Which sense is primarily used to experience visual arts?",
    options: [
      "Touch",
      "Hearing",
      "Sight",
      "Taste"
    ],
    answer: "Sight"
  },
  {
    question: "What do we call a sculpture that is designed to be viewed from all angles?",
    options: [
      "Relief sculpture",
      "2D art",
      "Freestanding sculpture",
      "Collage"
    ],
    answer: "Freestanding sculpture"
  },
  {
    question: "Which of the following helps convey emotion in a dance performance?",
    options: [
      "Steps only",
      "Facial expressions and movement",
      "Lighting alone",
      "Costume design"
    ],
    answer: "Facial expressions and movement"
  },
  {
    question: "What is typically used to stretch and support a canvas for painting?",
    options: [
      "Paper frame",
      "Wooden easel",
      "Drawing board",
      "Stretcher bars"
    ],
    answer: "Stretcher bars"
  },
  {
    question: "Which of the following is NOT a traditional musical instrument?",
    options: [
      "Talking drum",
      "Flute",
      "Saxophone",
      "Xylophone"
    ],
    answer: "Saxophone"
  },
  {
    question: "What is a key difference between drama and dance?",
    options: [
      "Drama involves sound, dance is silent",
      "Drama focuses on dialogue, dance emphasizes movement",
      "Drama uses color, dance does not",
      "Drama has costumes, dance does not"
    ],
    answer: "Drama focuses on dialogue, dance emphasizes movement"
  },
  {
    question: "Which part of a drawing helps to show where light is hitting an object?",
    options: [
      "Outline",
      "Shadow",
      "Highlight",
      "Background"
    ],
    answer: "Highlight"
  },
  {
    question: "Which principle of design involves organizing elements to feel stable and even?",
    options: [
      "Movement",
      "Emphasis",
      "Balance",
      "Unity"
    ],
    answer: "Balance"
  },
  {
    question: "Which of these tools is commonly used for applying ink in printmaking?",
    options: [
      "Palette knife",
      "Brush",
      "Brayer",
      "Ruler"
    ],
    answer: "Brayer"
  },
  {
    question: "What is the name for artwork that shows objects from everyday life?",
    options: [
      "Abstract art",
      "Still life",
      "Impressionism",
      "Graffiti"
    ],
    answer: "Still life"
  },
  {
    question: "Which of these is an important safety rule when using sharp tools?",
    options: [
      "Use them quickly",
      "Pass them blade-first",
      "Cut away from your body",
      "Never use them"
    ],
    answer: "Cut away from your body"
  },
  {
    question: "Which of these is a method of applying dye to fabric?",
    options: [
      "Stamping",
      "Coiling",
      "Weaving",
      "Tie-dye"
    ],
    answer: "Tie-dye"
  },
  {
    question: "In music, what is the term for a group of notes played in succession?",
    options: [
      "Harmony",
      "Chord",
      "Melody",
      "Beat"
    ],
    answer: "Melody"
  },
  {
    question: "Which of the following is a theme commonly explored in creative arts?",
    options: [
      "Mathematics",
      "Health statistics",
      "Social values",
      "Historical maps"
    ],
    answer: "Social values"
  },
  {
    question: "What is a monologue?",
    options: [
      "A poem sung aloud",
      "A dramatic speech by one character",
      "A duet between dancers",
      "A musical note"
    ],
    answer: "A dramatic speech by one character"
  },
  {
    question: "What do we call the process of planning and organizing a performance?",
    options: [
      "Choreography",
      "Sketching",
      "Directing",
      "Auditioning"
    ],
    answer: "Directing"
  },
  {
    question: "Which of the following is essential for good teamwork in performance arts?",
    options: [
      "Solo rehearsal",
      "Creativity",
      "Cooperation",
      "Drawing skills"
    ],
    answer: "Cooperation"
  },
  {
    question: "What is the result of mixing red and yellow?",
    options: [
      "Green",
      "Purple",
      "Orange",
      "Brown"
    ],
    answer: "Orange"
  },
  {
    question: "Which of the following would best describe 'tempo' in music?",
    options: [
      "Volume of sound",
      "Mood of the piece",
      "Speed of the beat",
      "Texture of the sound"
    ],
    answer: "Speed of the beat"
  },
  {
    question: "What is the main focus of stage design in drama?",
    options: [
      "Lighting only",
      "Creating the setting and mood",
      "Costume fitting",
      "Learning lines"
    ],
    answer: "Creating the setting and mood"
  },
  {
    question: "Which of these can be used to create texture in a painting?",
    options: [
      "Flat brush only",
      "Smooth paper",
      "Thick paint and layering",
      "Light shading only"
    ],
    answer: "Thick paint and layering"
  },
  {
    question: "Which of the following is a use of contrast in visual art?",
    options: [
      "To hide the subject",
      "To confuse the viewer",
      "To create focus and variety",
      "To remove details"
    ],
    answer: "To create focus and variety"
  },
  {
    question: "Which is the best reason to include audience feedback after a performance?",
    options: [
      "To entertain the cast",
      "To help performers improve",
      "To shorten the next show",
      "To announce a winner"
    ],
    answer: "To help performers improve"
  },
  {
    question: "Which of the following is typically used in low relief sculpture?",
    options: [
      "Deep carving",
      "Flat drawing",
      "Shallow carving",
      "Painting only"
    ],
    answer: "Shallow carving"
  },
  {
    question: "Which tool is essential in tie-dye design?",
    options: [
      "Brush",
      "Rubber bands",
      "Cutter",
      "Glue stick"
    ],
    answer: "Rubber bands"
  },
  {
    question: "Which of the following represents a performance involving both speech and movement?",
    options: [
      "Still life",
      "Drama",
      "Sketching",
      "Modeling"
    ],
    answer: "Drama"
  },
  {
    question: "What is the purpose of repetition in design?",
    options: [
      "To confuse the viewer",
      "To create rhythm and pattern",
      "To use more color",
      "To add text"
    ],
    answer: "To create rhythm and pattern"
  },
  {
    question: "What is a script in drama?",
    options: [
      "The costume list",
      "The lighting schedule",
      "The written dialogue and instructions",
      "The dance sequence"
    ],
    answer: "The written dialogue and instructions"
  },
  {
    question: "Which principle of design involves directing the viewer’s attention to one part of the work?",
    options: [
      "Unity",
      "Balance",
      "Emphasis",
      "Repetition"
    ],
    answer: "Emphasis"
  },
  {
    question: "Which of the following is an advantage of using recycled materials in art?",
    options: [
      "More expensive",
      "Unusual textures and sustainability",
      "Easier to throw away",
      "Less variety"
    ],
    answer: "Unusual textures and sustainability"
  },
  {
    question: "Which form of art tells a story through movement and music?",
    options: [
      "Dance drama",
      "Painting",
      "Mime only",
      "Drawing"
    ],
    answer: "Dance drama"
  },
  {
    question: "Which of these is a benefit of group performances?",
    options: [
      "Hiding mistakes",
      "Creative collaboration and confidence building",
      "Skipping rehearsals",
      "Solo attention"
    ],
    answer: "Creative collaboration and confidence building"
  },
  {
    question: "What do artists often use to plan large projects?",
    options: [
      "Script",
      "Sketchbook",
      "Costume",
      "Brushes"
    ],
    answer: "Sketchbook"
  },
  {
    question: "Which musical term describes a gradual increase in volume?",
    options: [
      "Diminuendo",
      "Legato",
      "Crescendo",
      "Staccato"
    ],
    answer: "Crescendo"
  },
  {
    question: "What is the role of lighting in performance art?",
    options: [
      "To decorate the ceiling",
      "To guide dancers",
      "To create mood and focus",
      "To record sound"
    ],
    answer: "To create mood and focus"
  },
  {
    question: "Which of these would be most useful for creating a 3D mask?",
    options: [
      "Crayons",
      "Poster paper",
      "Cardboard and glue",
      "Markers"
    ],
    answer: "Cardboard and glue"
  },
  {
    question: "Which of the following best describes a harmony in music?",
    options: [
      "Different notes played together that sound pleasant",
      "Fast beats only",
      "Repeated loud sounds",
      "One instrument playing"
    ],
    answer: "Different notes played together that sound pleasant"
  },
  {
    question: "What makes a costume effective in drama?",
    options: [
      "Being colorful",
      "Matching the role and time period",
      "Being expensive",
      "Being random"
    ],
    answer: "Matching the role and time period"
  },
  {
    question: "Which of these is an example of environmental art material?",
    options: [
      "Clay",
      "Plastic",
      "Twigs and leaves",
      "Acrylic paint"
    ],
    answer: "Twigs and leaves"
  },
  {
    question: "Why is brainstorming important in the creative process?",
    options: [
      "To finish work quickly",
      "To gather ideas and explore possibilities",
      "To reduce creativity",
      "To choose the easiest idea"
    ],
    answer: "To gather ideas and explore possibilities"
  },
  {
    question: "What is a key reason artists use symbolism?",
    options: [
      "To confuse the viewer",
      "To make work pretty",
      "To communicate deeper meanings",
      "To avoid using colors"
    ],
    answer: "To communicate deeper meanings"
  },
  {
    question: "Which performance skill helps maintain audience interest?",
    options: [
      "Stage fright",
      "Eye contact and expression",
      "Silence",
      "Random movement"
    ],
    answer: "Eye contact and expression"
  },
  {
    question: "Which of these tools is most commonly used to blend pencil shading?",
    options: [
      "Eraser",
      "Sharpener",
      "Tortillon (blending stump)",
      "Pen"
    ],
    answer: "Tortillon (blending stump)"
  },
  {
    question: "Which of the following design tools would help organize an idea visually?",
    options: [
      "Notebook",
      "Blueprint",
      "Mind map or mood board",
      "Canvas"
    ],
    answer: "Mind map or mood board"
  },
  {
    question: "Which of the following is used to create rhythm in music?",
    options: [
      "Chords",
      "Repeated beats and patterns",
      "Lyrics",
      "Tuning"
    ],
    answer: "Repeated beats and patterns"
  },
  {
    question: "What element of design refers to the lightness or darkness of a color?",
    options: [
      "Hue",
      "Tone",
      "Value",
      "Saturation"
    ],
    answer: "Value"
  },
  {
    question: "Which performance art uses body movement to tell a story without speech?",
    options: [
      "Mime",
      "Monologue",
      "Puppet show",
      "Choral reading"
    ],
    answer: "Mime"
  },
  {
    question: "What is a collage?",
    options: [
      "A painting using watercolor",
      "An artwork made by assembling different materials",
      "A sculpture of clay",
      "A musical instrument"
    ],
    answer: "An artwork made by assembling different materials"
  },
  {
    question: "Which type of movement in dance is usually slow and smooth?",
    options: [
      "Staccato",
      "Flowing movement",
      "Vibrato",
      "Rapid motion"
    ],
    answer: "Flowing movement"
  },
  {
    question: "In visual arts, what is meant by 'foreground'?",
    options: [
      "The objects farthest away",
      "The area behind the subject",
      "The space closest to the viewer",
      "The background"
    ],
    answer: "The space closest to the viewer"
  },
  {
    question: "Which material is best for modeling a simple clay sculpture?",
    options: [
      "Oil paint",
      "Paper",
      "Water",
      "Air-dry clay"
    ],
    answer: "Air-dry clay"
  },
  {
    question: "Why do artists sometimes create art with recycled materials?",
    options: [
      "It looks expensive",
      "To support the environment and reduce waste",
      "They have no other tools",
      "It’s more colorful"
    ],
    answer: "To support the environment and reduce waste"
  },
  {
    question: "Which of the following instruments produces sound by vibrating strings?",
    options: [
      "Drum",
      "Flute",
      "Xylophone",
      "Guitar"
    ],
    answer: "Guitar"
  },
  {
    question: "Which of these would be used to create a wax resist design?",
    options: [
      "Ink and pencil",
      "Candle and dye",
      "Charcoal and glue",
      "Crayon and eraser"
    ],
    answer: "Candle and dye"
  },
  {
    question: "What is the purpose of rehearsing a play before performance?",
    options: [
      "To surprise the actors",
      "To memorize lines and improve delivery",
      "To choose costumes",
      "To decorate the stage"
    ],
    answer: "To memorize lines and improve delivery"
  },
  {
    question: "Which art form combines visual art with storytelling?",
    options: [
      "Drama",
      "Painting",
      "Poetry",
      "Dance"
    ],
    answer: "Drama"
  },
  {
    question: "Which sense is most involved in appreciating music?",
    options: [
      "Sight",
      "Touch",
      "Hearing",
      "Smell"
    ],
    answer: "Hearing"
  },
  {
    question: "Which of the following is a warm color?",
    options: [
      "Blue",
      "Green",
      "Purple",
      "Orange"
    ],
    answer: "Orange"
  },
  {
    question: "In a drama performance, what is a 'cue'?",
    options: [
      "A type of costume",
      "A prompt for an actor’s action or line",
      "A spotlight",
      "A background song"
    ],
    answer: "A prompt for an actor’s action or line"
  },
  {
    question: "Which of the following best describes improvisation?",
    options: [
      "Performing with rehearsed steps",
      "Acting or creating on the spot without a script",
      "Wearing special costumes",
      "Using stage lights"
    ],
    answer: "Acting or creating on the spot without a script"
  },
  {
    question: "What is a sound effect in drama?",
    options: [
      "Background music",
      "Visual decoration",
      "A recorded or created sound to add meaning",
      "Dialogue"
    ],
    answer: "A recorded or created sound to add meaning"
  },
  {
    question: "What type of art involves shaping materials into 3D forms?",
    options: [
      "Drawing",
      "Sculpture",
      "Photography",
      "Weaving"
    ],
    answer: "Sculpture"
  },
  {
    question: "Which is NOT an element of design?",
    options: [
      "Line",
      "Shape",
      "Balance",
      "Color"
    ],
    answer: "Balance"
  },
  {
    question: "Which of the following is a reason for using props in drama?",
    options: [
      "To distract the actors",
      "To decorate the audience",
      "To support the story and characters",
      "To replace actors"
    ],
    answer: "To support the story and characters"
  },
  {
    question: "Which of these shows the proper order of the creative process?",
    options: [
      "Design – Imagine – Present – Brainstorm",
      "Brainstorm – Plan – Create – Present – Reflect",
      "Present – Paint – Dry – Draw",
      "Research – Paint – Frame – Rehearse"
    ],
    answer: "Brainstorm – Plan – Create – Present – Reflect"
  },
  {
    question: "In storytelling through art, what is a ‘theme’?",
    options: [
      "The size of the artwork",
      "The main message or idea",
      "The use of color",
      "The price of the material"
    ],
    answer: "The main message or idea"
  },
  {
    question: "Which of the following is a fabric decorating technique?",
    options: [
      "Carving",
      "Sewing",
      "Appliqué",
      "Modeling"
    ],
    answer: "Appliqué"
  },
  {
    question: "Which of these is a traditional Nigerian performance art?",
    options: [
      "Ballet",
      "Opera",
      "Masquerade dance",
      "Mime"
    ],
    answer: "Masquerade dance"
  },
  {
    question: "Which stage of a creative project involves testing ideas through sketches?",
    options: [
      "Reflection",
      "Research",
      "Planning",
      "Evaluation"
    ],
    answer: "Planning"
  },
  {
    question: "What role does color play in visual arts?",
    options: [
      "To erase mistakes",
      "To fix lighting",
      "To express mood and emotion",
      "To create sound"
    ],
    answer: "To express mood and emotion"
  },
  {
    question: "Which of these is a line quality?",
    options: [
      "Tone",
      "Smooth",
      "Rough",
      "Jagged"
    ],
    answer: "Jagged"
  },
  {
    question: "What is a major benefit of learning creative arts?",
    options: [
      "Improves scientific accuracy",
      "Develops imagination and self-expression",
      "Eliminates need for teamwork",
      "Focuses only on memorization"
    ],
    answer: "Develops imagination and self-expression"
  },
  {
    question: "Which material would you use for printmaking?",
    options: [
      "Mirror",
      "Woodblock",
      "Rope",
      "Feather"
    ],
    answer: "Woodblock"
  },
  {
    question: "In design, what does symmetry mean?",
    options: [
      "One side is different from the other",
      "Balance between opposite sides",
      "No color used",
      "A 3D shape"
    ],
    answer: "Balance between opposite sides"
  },
  {
    question: "Which of these is a digital tool for creating art?",
    options: [
      "Chisel",
      "Tablet and stylus",
      "Ruler",
      "Frame"
    ],
    answer: "Tablet and stylus"
  },
  {
    question: "Which of these is a skill developed through music education?",
    options: [
      "Typing",
      "Listening and rhythm",
      "Running",
      "Weaving"
    ],
    answer: "Listening and rhythm"
  },
  {
    question: "Which of the following helps build confidence in young performers?",
    options: [
      "Criticism",
      "Performance opportunities and praise",
      "Isolation",
      "Avoiding practice"
    ],
    answer: "Performance opportunities and praise"
  },
  {
    question: "What is the role of gesture in drama?",
    options: [
      "To decorate the stage",
      "To control lighting",
      "To communicate non-verbal actions",
      "To create costumes"
    ],
    answer: "To communicate non-verbal actions"
  },
  {
    question: "What do we call a short, repeated musical pattern?",
    options: [
      "Bridge",
      "Verse",
      "Loop",
      "Ballad"
    ],
    answer: "Loop"
  },
  {
    question: "Which of these would help in developing fine motor skills?",
    options: [
      "Painting with a brush",
      "Jumping",
      "Singing loudly",
      "Running"
    ],
    answer: "Painting with a brush"
  },
  {
    question: "Which of these encourages storytelling in children’s art?",
    options: [
      "Color matching only",
      "Drawing scenes and characters",
      "Copying others",
      "Using rulers only"
    ],
    answer: "Drawing scenes and characters"
  },
  {
    question: "What is the purpose of critique in creative arts?",
    options: [
      "To compare prices",
      "To punish mistakes",
      "To help improve and reflect",
      "To eliminate competition"
    ],
    answer: "To help improve and reflect"
  },
  {
    question: "Which of the following is most likely found in a dramatic script?",
    options: [
      "Bar graphs",
      "Dialogue and stage directions",
      "Color wheel",
      "Sheet music"
    ],
    answer: "Dialogue and stage directions"
  },
  {
    question: "Which of these can be used to create visual contrast?",
    options: [
      "Same shapes",
      "Matching colors",
      "Light and dark tones",
      "Same size"
    ],
    answer: "Light and dark tones"
  },
  {
    question: "Which of these art forms uses yarn or thread?",
    options: [
      "Sculpture",
      "Weaving",
      "Dance",
      "Acting"
    ],
    answer: "Weaving"
  },
  {
    question: "What is one way to show texture in drawing?",
    options: [
      "Solid coloring only",
      "Shading and lines",
      "Bright colors only",
      "Tracing"
    ],
    answer: "Shading and lines"
  },
  {
    question: "What type of dance tells a story and has a cultural background?",
    options: [
      "Freestyle",
      "Traditional dance",
      "Disco",
      "Breakdance"
    ],
    answer: "Traditional dance"
  },
  {
    question: "Which of these materials is best for puppetry?",
    options: [
      "Metal rods",
      "Yarn and fabric",
      "Glass",
      "Sand"
    ],
    answer: "Yarn and fabric"
  },
  {
    question: "Which of the following best describes 'choreography'?",
    options: [
      "Painting a picture",
      "Planning and arranging dance movements",
      "Making musical instruments",
      "Designing costumes"
    ],
    answer: "Planning and arranging dance movements"
  },
  {
    question: "What is the importance of traditional songs in cultural identity?",
    options: [
      "They make people sleepy",
      "They preserve history and values",
      "They replace written books",
      "They are used only for dancing"
    ],
    answer: "They preserve history and values"
  },
  {
    question: "Which material would be most appropriate for creating a papier-mâché sculpture?",
    options: [
      "Cement and wood",
      "Clay and sand",
      "Paper and glue",
      "Stone and water"
    ],
    answer: "Paper and glue"
  },
  {
    question: "What do we call the highness or lowness of a musical sound?",
    options: [
      "Pitch",
      "Tempo",
      "Volume",
      "Tone"
    ],
    answer: "Pitch"
  },
  {
    question: "In which art form are lines and shading used to create illusions of depth?",
    options: [
      "Drama",
      "Dance",
      "Drawing",
      "Singing"
    ],
    answer: "Drawing"
  },
  {
    question: "What is the main difference between abstract and realistic art?",
    options: [
      "Abstract art uses fewer colors",
      "Realistic art copies nature while abstract art emphasizes shapes and ideas",
      "Abstract art is always in black and white",
      "Realistic art uses only pencil"
    ],
    answer: "Realistic art copies nature while abstract art emphasizes shapes and ideas"
  },
  {
    question: "Which of the following best shows repetition in design?",
    options: [
      "Using only one color",
      "A pattern of dots repeated across a surface",
      "A random mix of images",
      "Drawing one object once"
    ],
    answer: "A pattern of dots repeated across a surface"
  },
  {
    question: "In drama, what is the main purpose of costumes?",
    options: [
      "To keep warm",
      "To make the actor laugh",
      "To help express character and setting",
      "To clean the stage"
    ],
    answer: "To help express character and setting"
  },
  {
    question: "Which of the following is an example of a percussion instrument?",
    options: [
      "Flute",
      "Trumpet",
      "Drum",
      "Violin"
    ],
    answer: "Drum"
  },
  {
    question: "Which of these is most important when composing a piece of music?",
    options: [
      "Using loud instruments only",
      "Having a clear theme and structure",
      "Repeating one note",
      "Drawing musical symbols"
    ],
    answer: "Having a clear theme and structure"
  },
  {
    question: "What does the term 'audience etiquette' refer to?",
    options: [
      "How actors behave",
      "How to draw a scene",
      "Proper behavior during performances",
      "Type of instruments played"
    ],
    answer: "Proper behavior during performances"
  },
  {
    question: "Which element of music controls the speed of a piece?",
    options: [
      "Pitch",
      "Tempo",
      "Harmony",
      "Melody"
    ],
    answer: "Tempo"
  },
  {
    question: "Which of these is NOT a stage direction?",
    options: [
      "Enter",
      "Exit",
      "Louder",
      "Color"
    ],
    answer: "Color"
  },
  {
    question: "What is the role of an art curator?",
    options: [
      "Performs on stage",
      "Plays music in a band",
      "Organizes and manages art exhibitions",
      "Teaches dance"
    ],
    answer: "Organizes and manages art exhibitions"
  },
  {
    question: "In storytelling, what is a climax?",
    options: [
      "The first line",
      "The end of the story",
      "The most intense or exciting part",
      "The background of the characters"
    ],
    answer: "The most intense or exciting part"
  },
  {
    question: "Which principle of design refers to the way elements are arranged to create stability?",
    options: [
      "Balance",
      "Color",
      "Texture",
      "Value"
    ],
    answer: "Balance"
  },
  {
    question: "What is the difference between a solo and a duet in performance?",
    options: [
      "Solo is quiet; duet is loud",
      "Solo is performed by one person; duet by two",
      "Duet uses more costumes",
      "Solo uses drums only"
    ],
    answer: "Solo is performed by one person; duet by two"
  },
  {
    question: "Which of the following is a reason why artists sketch before painting?",
    options: [
      "To waste time",
      "To plan the composition and layout",
      "To avoid using paint",
      "To draw without thinking"
    ],
    answer: "To plan the composition and layout"
  },
  {
    question: "Which of the following is used to create harmony in music?",
    options: [
      "Color blending",
      "Singing different notes together",
      "Drawing multiple shapes",
      "Using props"
    ],
    answer: "Singing different notes together"
  },
  {
    question: "What is meant by the term 'beat' in music?",
    options: [
      "The words in a song",
      "The pattern of colors",
      "A regular pulse or rhythm",
      "The height of sound"
    ],
    answer: "A regular pulse or rhythm"
  },
  {
    question: "Which of the following is an example of a folk art form?",
    options: [
      "Hip hop dance",
      "Rock music",
      "Kente weaving",
      "Graffiti"
    ],
    answer: "Kente weaving"
  },
  {
    question: "Which of these skills is developed through group performance activities?",
    options: [
      "Self-isolation",
      "Teamwork and communication",
      "Copying silently",
      "Solo memorization"
    ],
    answer: "Teamwork and communication"
  },
  {
    question: "Which art element refers to the surface quality of an object, either real or implied?",
    options: [
      "Shape",
      "Value",
      "Texture",
      "Line"
    ],
    answer: "Texture"
  },
  {
    question: "What is the significance of call and response in African music?",
    options: [
      "To confuse the audience",
      "To create echo effects",
      "To engage the audience in participation",
      "To make the song longer"
    ],
    answer: "To engage the audience in participation"
  },
  {
    question: "What is an installation in art?",
    options: [
      "Painting on canvas",
      "3D artwork created to transform a space",
      "Wall carving",
      "Small sculpture only"
    ],
    answer: "3D artwork created to transform a space"
  },
  {
    question: "Which of the following is a method of developing creative ideas?",
    options: [
      "Imitation only",
      "Brainstorming",
      "Guessing blindly",
      "Copying exactly"
    ],
    answer: "Brainstorming"
  },
  {
    question: "Which traditional Ghanaian instrument is played by striking?",
    options: [
      "Kora",
      "Atumpan",
      "Seperewa",
      "Flute"
    ],
    answer: "Atumpan"
  },
  {
    question: "What is a storyboard used for in performance planning?",
    options: [
      "To record music notes",
      "To arrange costume materials",
      "To visually map out scenes",
      "To choose colors"
    ],
    answer: "To visually map out scenes"
  },
  {
    question: "In dance, what does the term 'formation' mean?",
    options: [
      "The sound of the music",
      "The storyline of the performance",
      "The arrangement of dancers in space",
      "The costumes worn"
    ],
    answer: "The arrangement of dancers in space"
  },
  {
    question: "What is the function of a script in a drama production?",
    options: [
      "To build the stage",
      "To decorate the costumes",
      "To provide dialogue and stage directions",
      "To record music"
    ],
    answer: "To provide dialogue and stage directions"
  },
  {
    question: "Which of these is NOT a reason for learning creative arts?",
    options: [
      "To develop self-expression",
      "To encourage critical thinking",
      "To improve artistic skills",
      "To avoid teamwork"
    ],
    answer: "To avoid teamwork"
  },
  {
    question: "What does 'contrast' in design help to achieve?",
    options: [
      "Harmony only",
      "Monotony",
      "Visual interest and emphasis",
      "Same appearance throughout"
    ],
    answer: "Visual interest and emphasis"
  },
  {
    question: "What role do puppets often play in educational performances?",
    options: [
      "Only for decoration",
      "To entertain teachers only",
      "To deliver messages and teach lessons",
      "To hide actors"
    ],
    answer: "To deliver messages and teach lessons"
  },
  {
    question: "What is the primary reason for practicing stage movement in drama?",
    options: [
      "To rehearse walking only",
      "To create noise",
      "To express emotion and support storytelling",
      "To distract the audience"
    ],
    answer: "To express emotion and support storytelling"
  },
  {
    question: "Which color scheme uses opposite colors on the color wheel?",
    options: [
      "Analogous",
      "Monochromatic",
      "Complementary",
      "Neutral"
    ],
    answer: "Complementary"
  },
  {
    question: "Which of the following is an example of environmental art?",
    options: [
      "Graffiti on classroom walls",
      "Sculptures made from natural materials outdoors",
      "A painting on paper",
      "Cartoons in a book"
    ],
    answer: "Sculptures made from natural materials outdoors"
  },
  {
    question: "What is a musical ensemble?",
    options: [
      "A solo performance",
      "A group of musicians performing together",
      "A dance team",
      "A sound machine"
    ],
    answer: "A group of musicians performing together"
  },
  {
    question: "What is meant by 'personal style' in art?",
    options: [
      "Copying a master artist",
      "Using only black and white",
      "An artist’s unique way of creating art",
      "Following strict rules"
    ],
    answer: "An artist’s unique way of creating art"
  },
  {
    question: "Which of the following is used in batik design?",
    options: [
      "Acrylic paint",
      "Wax and dye",
      "Charcoal and glue",
      "Pencil and crayon"
    ],
    answer: "Wax and dye"
  },
  {
    question: "What is the benefit of collaborative art projects?",
    options: [
      "They reduce effort",
      "They eliminate individual ideas",
      "They develop teamwork and shared creativity",
      "They limit expression"
    ],
    answer: "They develop teamwork and shared creativity"
  },
  {
    question: "Which of these is a digital art form?",
    options: [
      "Clay modeling",
      "Pencil shading",
      "Graphic design",
      "Basket weaving"
    ],
    answer: "Graphic design"
  },
  {
    question: "In drama, what does the term 'blocking' mean?",
    options: [
      "Covering the audience’s view",
      "Organizing stage lighting",
      "Planning actors' movement on stage",
      "Hiding costumes"
    ],
    answer: "Planning actors' movement on stage"
  },
  {
    question: "Which of the following is a tool used in fabric decoration?",
    options: [
      "Loom",
      "Brush",
      "Spray bottle",
      "All of the above"
    ],
    answer: "All of the above"
  },
  {
    question: "What element of art is used to outline, define shapes, or suggest movement?",
    options: [
      "Texture",
      "Line",
      "Space",
      "Tone"
    ],
    answer: "Line"
  },
  {
    question: "Which performance activity helps students build vocal confidence?",
    options: [
      "Choral reading",
      "Drawing",
      "Modeling clay",
      "Sewing"
    ],
    answer: "Choral reading"
  },
  {
    question: "Which of the following is NOT a feature of a good poster design?",
    options: [
      "Clear message",
      "Too much text",
      "Attractive visuals",
      "Bold title"
    ],
    answer: "Too much text"
  },
  {
    question: "What is the main focus of improvisation in drama?",
    options: [
      "Using a script exactly",
      "Memorizing all lines",
      "Spontaneous creation of dialogue and action",
      "Only using costumes"
    ],
    answer: "Spontaneous creation of dialogue and action"
  },
  {
    question: "Which color is typically associated with peace?",
    options: [
      "Red",
      "Black",
      "White",
      "Orange"
    ],
    answer: "White"
  },
  {
    question: "Which of these is a traditional Ghanaian festival dance?",
    options: [
      "Agbadza",
      "Hip hop",
      "Waltz",
      "Tango"
    ],
    answer: "Agbadza"
  },
  {
    question: "What type of perspective drawing uses one vanishing point?",
    options: [
      "Two-point perspective",
      "Flat drawing",
      "One-point perspective",
      "Isometric drawing"
    ],
    answer: "One-point perspective"
  },
  {
    question: "In which situation would a monologue be used in drama?",
    options: [
      "A group dance",
      "Solo speech expressing a character's thoughts",
      "Background music",
      "Fight scene"
    ],
    answer: "Solo speech expressing a character's thoughts"
  },
  {
    question: "Which sense is most important in appreciating a sculpture?",
    options: [
      "Taste",
      "Smell",
      "Touch",
      "Sight"
    ],
    answer: "Sight"
  },
  {
    question: "Which of the following is a technique used in textile design?",
    options: [
      "Weaving",
      "Singing",
      "Acting",
      "Drawing cartoons"
    ],
    answer: "Weaving"
  },
  {
    question: "What is the function of a mask in traditional African performance?",
    options: [
      "To protect eyes",
      "To store items",
      "To represent spirits or characters",
      "To cover mistakes"
    ],
    answer: "To represent spirits or characters"
  },
  {
    question: "Which of these is NOT an element of music?",
    options: [
      "Rhythm",
      "Melody",
      "Shape",
      "Pitch"
    ],
    answer: "Shape"
  },
  {
    question: "Which of these materials is biodegradable?",
    options: [
      "Plastic bottle",
      "Paper",
      "Metal rod",
      "Glass cup"
    ],
    answer: "Paper"
  },
  {
    question: "Which activity is most likely to develop fine motor skills?",
    options: [
      "Running",
      "Dancing",
      "Painting small details",
      "Singing loudly"
    ],
    answer: "Painting small details"
  },
  {
    question: "What is the term for the area around and between objects in artwork?",
    options: [
      "Line",
      "Color",
      "Space",
      "Form"
    ],
    answer: "Space"
  },
  {
    question: "What does the term 'tempo' in music refer to?",
    options: [
      "The loudness of sound",
      "The pitch of a note",
      "The speed of the beat",
      "The color of the sound"
    ],
    answer: "The speed of the beat"
  },
  {
    question: "In dance, what does the term 'canon' mean?",
    options: [
      "A traditional costume",
      "Movement performed one after the other",
      "Fast movements only",
      "Group improvisation"
    ],
    answer: "Movement performed one after the other"
  },
  {
    question: "Which of these is used for shading in pencil drawing?",
    options: [
      "Water",
      "Charcoal stick",
      "Cross-hatching",
      "Glue"
    ],
    answer: "Cross-hatching"
  },
  {
    question: "Which of the following is a traditional fabric from Northern Ghana?",
    options: [
      "Kente",
      "Adinkra",
      "Fugu",
      "Tie-dye"
    ],
    answer: "Fugu"
  },
  {
    question: "What do you call a musical symbol that raises a note by a half step?",
    options: [
      "Flat",
      "Sharp",
      "Natural",
      "Pause"
    ],
    answer: "Sharp"
  },
  {
    question: "Which of the following is a danger of improper tool use in art?",
    options: [
      "Better creativity",
      "Increased accuracy",
      "Injury or accidents",
      "Faster work"
    ],
    answer: "Injury or accidents"
  },
  {
    question: "Why is critique important in art?",
    options: [
      "To mock others",
      "To reduce creativity",
      "To provide helpful feedback for improvement",
      "To sell art quickly"
    ],
    answer: "To provide helpful feedback for improvement"
  },
  {
    question: "What is one role of a director in drama?",
    options: [
      "Creates lighting only",
      "Directs audience members",
      "Guides the performance and interprets the script",
      "Writes music"
    ],
    answer: "Guides the performance and interprets the script"
  },
  {
    question: "What is the main purpose of rehearsal in performance arts?",
    options: [
      "To waste time",
      "To memorize costumes",
      "To prepare and refine the performance",
      "To avoid performance"
    ],
    answer: "To prepare and refine the performance"
  },
  {
    question: "Which of these is the best reason to use local materials in art?",
    options: [
      "They are expensive",
      "They are hard to find",
      "They promote cultural identity and creativity",
      "They are imported"
    ],
    answer: "They promote cultural identity and creativity"
  },
  {
    question: "What type of balance shows both sides of a design being equal?",
    options: [
      "Radial",
      "Asymmetrical",
      "Symmetrical",
      "Irregular"
    ],
    answer: "Symmetrical"
  },
  {
    question: "Which of these instruments is classified as a wind instrument?",
    options: [
      "Xylophone",
      "Drum",
      "Flute",
      "Guitar"
    ],
    answer: "Flute"
  },
  {
    question: "Why is contrast used in visual art?",
    options: [
      "To hide details",
      "To show similarity",
      "To create interest and focus",
      "To reduce movement"
    ],
    answer: "To create interest and focus"
  },
  {
    question: "What is a prop in theatre?",
    options: [
      "A lighting instrument",
      "A type of costume",
      "An object used by actors",
      "A musical instrument"
    ],
    answer: "An object used by actors"
  },
  {
    question: "Which of these is the best way to show unity in a painting?",
    options: [
      "Use of similar elements throughout the composition",
      "Using random lines only",
      "Ignoring color harmony",
      "Using many unrelated images"
    ],
    answer: "Use of similar elements throughout the composition"
  },
  {
    question: "Which of the following is a movement skill in dance?",
    options: [
      "Jumping",
      "Speaking",
      "Sewing",
      "Sitting"
    ],
    answer: "Jumping"
  },
  {
    question: "What is the best way to keep brushes clean after painting?",
    options: [
      "Leave them in paint",
      "Wash thoroughly with water or thinner",
      "Break the bristles",
      "Dry them with glue"
    ],
    answer: "Wash thoroughly with water or thinner"
  },
  {
    question: "Which of the following best describes a motif in design?",
    options: [
      "A type of music",
      "A repeated element or pattern",
      "An actor's dialogue",
      "A dance costume"
    ],
    answer: "A repeated element or pattern"
  },
  {
    question: "What is a jingle in advertising?",
    options: [
      "A dance step",
      "A short catchy song or tune",
      "A poster design",
      "A drama scene"
    ],
    answer: "A short catchy song or tune"
  },
  {
    question: "Which sense is most used when performing a song?",
    options: [
      "Sight",
      "Taste",
      "Smell",
      "Hearing"
    ],
    answer: "Hearing"
  },
  {
    question: "Which traditional Ghanaian musical instrument uses strings?",
    options: [
      "Kora",
      "Atumpan",
      "Gong-gong",
      "Xylophone"
    ],
    answer: "Kora"
  },
  {
    question: "Which of these shows rhythm in visual art?",
    options: [
      "Random lines",
      "Empty space",
      "Repeating patterns or shapes",
      "One dot only"
    ],
    answer: "Repeating patterns or shapes"
  },
  {
    question: "What does 'foreground' refer to in a picture?",
    options: [
      "The middle of the image",
      "The part that appears far away",
      "The nearest part of the image",
      "The color used"
    ],
    answer: "The nearest part of the image"
  },
  {
    question: "Which of these best promotes cultural preservation through the arts?",
    options: [
      "Ignoring traditions",
      "Documenting traditional dances and songs",
      "Using only foreign materials",
      "Copying modern trends"
    ],
    answer: "Documenting traditional dances and songs"
  },
  {
    question: "What is the main goal of costume design?",
    options: [
      "To keep actors warm",
      "To distract the audience",
      "To visually support character and setting",
      "To block sound"
    ],
    answer: "To visually support character and setting"
  },
  {
    question: "What is meant by 'medium' in art?",
    options: [
      "The artist's size",
      "The material or technique used",
      "The drawing paper only",
      "A type of color"
    ],
    answer: "The material or technique used"
  },
  {
    question: "What is one key difference between drama and storytelling?",
    options: [
      "Drama uses puppets only",
      "Storytelling is always written",
      "Drama uses action and dialogue while storytelling is narration",
      "Storytelling has no audience"
    ],
    answer: "Drama uses action and dialogue while storytelling is narration"
  },
  {
    question: "Why is observation important in art?",
    options: [
      "To copy exactly",
      "To develop accuracy and creativity",
      "To memorize names",
      "To finish quickly"
    ],
    answer: "To develop accuracy and creativity"
  },
  {
    question: "Which of these is a way to appreciate others’ artworks?",
    options: [
      "Laugh at mistakes",
      "Give constructive feedback",
      "Ignore the artist",
      "Destroy the work"
    ],
    answer: "Give constructive feedback"
  },
  {
    question: "What is the role of lighting in theatre?",
    options: [
      "Only to decorate",
      "To disturb actors",
      "To enhance mood and visibility",
      "To heat the stage"
    ],
    answer: "To enhance mood and visibility"
  },
  {
    question: "What does harmony in music involve?",
    options: [
      "No instruments",
      "Different notes sounding good together",
      "Loud drumming",
      "Repeating one note"
    ],
    answer: "Different notes sounding good together"
  },
  {
    question: "What is the benefit of singing in rounds?",
    options: [
      "It helps with dancing",
      "It creates harmony and layering",
      "It removes melody",
      "It is done silently"
    ],
    answer: "It creates harmony and layering"
  },
  {
    question: "Which of these is the correct sequence in the design process?",
    options: [
      "Sketch, Research, Brainstorm, Finish",
      "Research, Brainstorm, Sketch, Final design",
      "Final, Brainstorm, Research",
      "Color, Cut, Sketch"
    ],
    answer: "Research, Brainstorm, Sketch, Final design"
  },
  {
    question: "Which of the following tools is commonly used for carving wood?",
    options: [
      "Pencil",
      "Chisel",
      "Brush",
      "Eraser"
    ],
    answer: "Chisel"
  },
  {
    question: "What does the term 'composition' mean in visual art?",
    options: [
      "The tools used",
      "The story behind the art",
      "The arrangement of elements in an artwork",
      "The artist's name"
    ],
    answer: "The arrangement of elements in an artwork"
  },
  {
    question: "Which of the following helps in preserving paintings?",
    options: [
      "Hanging in direct sunlight",
      "Keeping them in a damp place",
      "Applying a protective varnish",
      "Leaving them outdoors"
    ],
    answer: "Applying a protective varnish"
  },
  {
    question: "Which technique is used to apply wax and dye to cloth?",
    options: [
      "Silk screening",
      "Batik",
      "Embossing",
      "Crocheting"
    ],
    answer: "Batik"
  },
  {
    question: "In music, which note is the highest in pitch?",
    options: [
      "Do",
      "La",
      "Ti",
      "So"
    ],
    answer: "Ti"
  },
  {
    question: "What is the meaning of ‘tempo’ in musical performance?",
    options: [
      "Time signature",
      "Pitch level",
      "Speed of the music",
      "Volume level"
    ],
    answer: "Speed of the music"
  },
  {
    question: "Which of the following is a type of local musical instrument in Ghana?",
    options: [
      "Harmonica",
      "Talking drum",
      "Violin",
      "Trumpet"
    ],
    answer: "Talking drum"
  },
  {
    question: "Which of the following is a responsibility of the audience in drama?",
    options: [
      "Direct the actors",
      "Interrupt the play",
      "Watch and respond respectfully",
      "Control the lighting"
    ],
    answer: "Watch and respond respectfully"
  },
  {
    question: "Which technique is used in drawing to make objects appear 3D?",
    options: [
      "Scribbling",
      "Coloring",
      "Shading",
      "Outlining"
    ],
    answer: "Shading"
  },
  {
    question: "In drama, what does 'stage left' mean?",
    options: [
      "Left side of the audience",
      "Right side of the stage from the actor’s view",
      "Left side of the stage from the actor’s view",
      "Back of the stage"
    ],
    answer: "Left side of the stage from the actor’s view"
  },
  {
    question: "Which of the following principles of design deals with visual weight?",
    options: [
      "Unity",
      "Balance",
      "Contrast",
      "Emphasis"
    ],
    answer: "Balance"
  },
  {
    question: "A good performance should be:",
    options: [
      "Boring and slow",
      "Poorly rehearsed",
      "Lively and well-rehearsed",
      "Uncoordinated"
    ],
    answer: "Lively and well-rehearsed"
  },
  {
    question: "Which of these art forms combines movement, music, and expression?",
    options: [
      "Drawing",
      "Painting",
      "Dance",
      "Weaving"
    ],
    answer: "Dance"
  },
  {
    question: "The part of a story where problems are resolved is called the:",
    options: [
      "Conflict",
      "Climax",
      "Exposition",
      "Resolution"
    ],
    answer: "Resolution"
  },
  {
    question: "Which of the following is a recyclable material in art?",
    options: [
      "Used paper",
      "Food waste",
      "Gasoline",
      "Plastic wrap with oil"
    ],
    answer: "Used paper"
  },
  {
    question: "Which of these art tools is used for blending in shading?",
    options: [
      "Pen",
      "Eraser",
      "Tortillon",
      "Ruler"
    ],
    answer: "Tortillon"
  },
  {
    question: "What is the function of rhythm in dance?",
    options: [
      "Create costumes",
      "Organize steps in time with music",
      "Control volume",
      "Draw a map"
    ],
    answer: "Organize steps in time with music"
  },
  {
    question: "Which of these is a form of textile decoration?",
    options: [
      "Carving",
      "Weaving",
      "Printing",
      "Casting"
    ],
    answer: "Printing"
  },
  {
    question: "A successful group performance requires:",
    options: [
      "Only the leader working",
      "No cooperation",
      "Teamwork and practice",
      "Random movements"
    ],
    answer: "Teamwork and practice"
  },
  {
    question: "In sculpture, 'relief' refers to:",
    options: [
      "A painting style",
      "Flat design",
      "Sculpture raised from a background",
      "A type of dance"
    ],
    answer: "Sculpture raised from a background"
  },
  {
    question: "Which of the following encourages creativity in learners?",
    options: [
      "Punishing them",
      "Discouraging exploration",
      "Allowing experimentation",
      "Limiting materials"
    ],
    answer: "Allowing experimentation"
  },
  {
    question: "A drawing of an object’s shape without shading is called:",
    options: [
      "Sketch",
      "Silhouette",
      "Outline",
      "Shadow"
    ],
    answer: "Outline"
  },
  {
    question: "The climax of a story is the point of:",
    options: [
      "Introduction",
      "Greatest tension",
      "Resolution",
      "Conflict start"
    ],
    answer: "Greatest tension"
  },
  {
    question: "Which of the following is an element of art?",
    options: [
      "Balance",
      "Movement",
      "Texture",
      "Unity"
    ],
    answer: "Texture"
  },
  {
    question: "Which of these is a function of design in everyday life?",
    options: [
      "Confuse users",
      "Improve usability and beauty",
      "Destroy materials",
      "Make objects harder to use"
    ],
    answer: "Improve usability and beauty"
  },
  {
    question: "Which art process involves folding and tying fabric before dyeing?",
    options: [
      "Knotting",
      "Stamping",
      "Tie-dye",
      "Crocheting"
    ],
    answer: "Tie-dye"
  },
  {
    question: "Which principle of art helps lead the viewer's eye through an artwork?",
    options: [
      "Movement",
      "Form",
      "Shape",
      "Color"
    ],
    answer: "Movement"
  },
  {
    question: "In music, what is a scale?",
    options: [
      "A type of dance",
      "A group of pitches in sequence",
      "A color pattern",
      "A music box"
    ],
    answer: "A group of pitches in sequence"
  },
  {
    question: "What is the main purpose of art in culture?",
    options: [
      "Confuse the youth",
      "Express and preserve identity and beliefs",
      "Create conflict",
      "Make laws"
    ],
    answer: "Express and preserve identity and beliefs"
  },
  {
    question: "What is a storyboard used for?",
    options: [
      "Mixing paints",
      "Sewing clothes",
      "Planning scenes in film or drama",
      "Drawing still life"
    ],
    answer: "Planning scenes in film or drama"
  },
  {
    question: "Which of the following is used to create rhythm in music?",
    options: [
      "Beats and patterns",
      "Color and light",
      "Brush and paint",
      "Script and dialogue"
    ],
    answer: "Beats and patterns"
  },
  {
    question: "Which action shows proper audience behavior?",
    options: [
      "Talking loudly during performance",
      "Clapping at the right time",
      "Interrupting the actors",
      "Eating and making noise"
    ],
    answer: "Clapping at the right time"
  },
  {
    question: "Why is symmetry important in design?",
    options: [
      "It creates confusion",
      "It helps balance and harmony",
      "It removes detail",
      "It shows randomness"
    ],
    answer: "It helps balance and harmony"
  },
  {
    question: "What does ‘genre’ mean in drama or music?",
    options: [
      "The audience name",
      "A performance error",
      "A style or category",
      "A costume type"
    ],
    answer: "A style or category"
  },
  {
    question: "Which of these would NOT be used in drama performance?",
    options: [
      "Script",
      "Canvas",
      "Props",
      "Stage"
    ],
    answer: "Canvas"
  },
  {
    question: "What is harmony in design?",
    options: [
      "Using random ideas",
      "Combining elements to create unity",
      "Overusing shapes",
      "Ignoring patterns"
    ],
    answer: "Combining elements to create unity"
  },
  {
    question: "What is the main role of background music in theatre?",
    options: [
      "Disturb the dialogue",
      "Provide atmosphere and mood",
      "Lead the actors",
      "Replace sound effects"
    ],
    answer: "Provide atmosphere and mood"
  },
  {
    question: "Which material is best suited for clay modeling?",
    options: [
      "Cement",
      "Sandpaper",
      "Soft clay",
      "Hard plastic"
    ],
    answer: "Soft clay"
  },
  {
    question: "Which of these helps protect the environment in art practice?",
    options: [
      "Using harmful chemicals",
      "Disposing paint in rivers",
      "Using eco-friendly materials",
      "Burning plastic waste"
    ],
    answer: "Using eco-friendly materials"
  },
  {
    question: "Which of the following best defines ‘abstract art’?",
    options: [
      "A realistic drawing",
      "An artwork that does not represent real objects",
      "A traditional portrait",
      "A landscape painting"
    ],
    answer: "An artwork that does not represent real objects"
  },
  {
    question: "Which of the following best describes a stage backdrop?",
    options: [
      "A costume",
      "A musical instrument",
      "Scenery placed behind actors",
      "A dance prop"
    ],
    answer: "Scenery placed behind actors"
  },
  {
    question: "What is the purpose of rehearsal in a play production?",
    options: [
      "Memorize scripts only",
      "Try new costumes",
      "Improve performance through practice",
      "Sleep during performance"
    ],
    answer: "Improve performance through practice"
  },
  {
    question: "A musical staff consists of how many lines?",
    options: [
      "3",
      "4",
      "5",
      "6"
    ],
    answer: "5"
  },
  {
    question: "Which of the following is a quality of good stage presence?",
    options: [
      "Turning your back to audience",
      "Speaking clearly and confidently",
      "Forgetting lines",
      "Hiding behind set"
    ],
    answer: "Speaking clearly and confidently"
  },
  {
    question: "What is the role of a costume in a performance?",
    options: [
      "To entertain the crew",
      "To support the character and story",
      "To confuse the viewer",
      "To match the set color"
    ],
    answer: "To support the character and story"
  },
  {
    question: "Which of these is NOT a performing art?",
    options: [
      "Painting",
      "Dance",
      "Drama",
      "Music"
    ],
    answer: "Painting"
  },
  {
    question: "In storytelling, a moral is the:",
    options: [
      "Name of the hero",
      "Time of the story",
      "Lesson or message",
      "Type of costume"
    ],
    answer: "Lesson or message"
  },
  {
    question: "Which of these materials is commonly used for weaving?",
    options: [
      "Yarn",
      "Water",
      "Chalk",
      "Charcoal"
    ],
    answer: "Yarn"
  },
  {
    question: "Which of the following is the best definition of calligraphy?",
    options: [
      "Freehand painting",
      "Decorative handwriting",
      "Finger painting",
      "Watercolor sketching"
    ],
    answer: "Decorative handwriting"
  },
  {
    question: "In visual art, what is a mural?",
    options: [
      "A sculpture made of metal",
      "A painting on a wall",
      "A carved wooden panel",
      "A paper folding design"
    ],
    answer: "A painting on a wall"
  },
  {
    question: "What tool is used in sculpture for smoothing surfaces?",
    options: [
      "Pencil",
      "Sandpaper",
      "Brush",
      "Cloth"
    ],
    answer: "Sandpaper"
  },
  {
    question: "The art element used to create a sense of distance in landscape drawing is:",
    options: [
      "Line",
      "Color",
      "Perspective",
      "Texture"
    ],
    answer: "Perspective"
  },
  {
    question: "Which of the following is used for making beadwork?",
    options: [
      "Clay",
      "Thread and beads",
      "Charcoal and paper",
      "Leaves and ink"
    ],
    answer: "Thread and beads"
  },
  {
    question: "A play script includes:",
    options: [
      "Only character names",
      "Instructions for lighting only",
      "Dialogue and stage directions",
      "Dance choreography"
    ],
    answer: "Dialogue and stage directions"
  },
  {
    question: "Which part of a story introduces characters and setting?",
    options: [
      "Climax",
      "Conflict",
      "Exposition",
      "Resolution"
    ],
    answer: "Exposition"
  },
  {
    question: "Which art activity uses loops and stitches with thread or yarn?",
    options: [
      "Casting",
      "Crocheting",
      "Printing",
      "Painting"
    ],
    answer: "Crocheting"
  },
  {
    question: "Which of the following is an example of dramatic art?",
    options: [
      "Singing a solo",
      "Acting a play",
      "Drawing a still life",
      "Playing violin"
    ],
    answer: "Acting a play"
  },
  {
    question: "In music, dynamics refer to:",
    options: [
      "Tempo changes",
      "Loudness and softness",
      "Pitch accuracy",
      "Harmony types"
    ],
    answer: "Loudness and softness"
  },
  {
    question: "A musical instrument made from a hollow gourd and net of beads is called:",
    options: [
      "Kete",
      "Shekere",
      "Claves",
      "Maracas"
    ],
    answer: "Shekere"
  },
  {
    question: "Which of the following is a product of textile design?",
    options: [
      "Bracelet",
      "Batakari",
      "Photograph",
      "Poster"
    ],
    answer: "Batakari"
  },
  {
    question: "What is improvisation in drama?",
    options: [
      "Using costumes",
      "Rehearsed performance",
      "Creating and performing without a script",
      "Singing in a group"
    ],
    answer: "Creating and performing without a script"
  },
  {
    question: "Which of these is an element of dance?",
    options: [
      "Background",
      "Choreography",
      "Form",
      "Dialogue"
    ],
    answer: "Choreography"
  },
  {
    question: "In art, 'contrast' is used to:",
    options: [
      "Hide objects",
      "Blend all parts",
      "Create visual interest through differences",
      "Repeat patterns"
    ],
    answer: "Create visual interest through differences"
  },
  {
    question: "A motif in textile design is:",
    options: [
      "A song rhythm",
      "A dance movement",
      "A repeated design pattern",
      "A type of sculpture"
    ],
    answer: "A repeated design pattern"
  },
  {
    question: "Which material is best for basket weaving?",
    options: [
      "Metal wire",
      "Plastic wrap",
      "Raffia or straw",
      "Paper towel"
    ],
    answer: "Raffia or straw"
  },
  {
    question: "The use of symbols in art is meant to:",
    options: [
      "Decorate without meaning",
      "Confuse the audience",
      "Represent ideas or concepts",
      "Draw maps"
    ],
    answer: "Represent ideas or concepts"
  },
  {
    question: "What is choreography?",
    options: [
      "Storytelling technique",
      "Dance movement planning",
      "Lighting design",
      "Clay modeling method"
    ],
    answer: "Dance movement planning"
  },
  {
    question: "Which of the following is an example of a traditional Ghanaian art form?",
    options: [
      "Graffiti",
      "Kente weaving",
      "Digital painting",
      "Origami"
    ],
    answer: "Kente weaving"
  },
  {
    question: "Which of these is a function of puppetry in education?",
    options: [
      "Only to entertain",
      "To confuse learners",
      "To teach values and lessons",
      "To waste time"
    ],
    answer: "To teach values and lessons"
  },
  {
    question: "What is a sketch in drawing?",
    options: [
      "A finished painting",
      "A quick, rough drawing",
      "A sculpture",
      "A photo"
    ],
    answer: "A quick, rough drawing"
  },
  {
    question: "Which of these tools is used in paper craft?",
    options: [
      "Scissors",
      "Chisel",
      "Easel",
      "Mallet"
    ],
    answer: "Scissors"
  },
  {
    question: "Which of the following best promotes safety in the art studio?",
    options: [
      "Running with sharp tools",
      "Using materials carefully",
      "Leaving spills unattended",
      "Touching hot surfaces"
    ],
    answer: "Using materials carefully"
  },
  {
    question: "The arrangement of light and dark in an artwork is called:",
    options: [
      "Contrast",
      "Perspective",
      "Form",
      "Tone"
    ],
    answer: "Tone"
  },
  {
    question: "Which of these contributes to effective storytelling?",
    options: [
      "Monotone voice",
      "Lack of gestures",
      "Clear voice and expression",
      "No interaction"
    ],
    answer: "Clear voice and expression"
  },
  {
    question: "Which art form combines spoken word and action?",
    options: [
      "Sculpture",
      "Painting",
      "Drama",
      "Photography"
    ],
    answer: "Drama"
  },
  {
    question: "Which color is formed by mixing red and yellow?",
    options: [
      "Green",
      "Purple",
      "Orange",
      "Blue"
    ],
    answer: "Orange"
  },
  {
    question: "Which of these is an example of performance art?",
    options: [
      "Dancing on stage",
      "Drawing in a sketchbook",
      "Framing a photo",
      "Printing a cloth"
    ],
    answer: "Dancing on stage"
  },
  {
    question: "In music, which instrument family does the trumpet belong to?",
    options: [
      "String",
      "Percussion",
      "Brass",
      "Woodwind"
    ],
    answer: "Brass"
  },
  {
    question: "What is the purpose of stage lighting?",
    options: [
      "Heat the actors",
      "Decorate the audience",
      "Create mood and focus attention",
      "Cover shadows"
    ],
    answer: "Create mood and focus attention"
  },
  {
    question: "Which of these is used for traditional face painting in Ghana?",
    options: [
      "Nail polish",
      "Acrylic",
      "Clay and charcoal",
      "Watercolor"
    ],
    answer: "Clay and charcoal"
  },
  {
    question: "Which of these is not an element of visual art?",
    options: [
      "Shape",
      "Value",
      "Tempo",
      "Texture"
    ],
    answer: "Tempo"
  },
  {
    question: "Why is it important to warm up before dancing?",
    options: [
      "To avoid sweating",
      "To relax too much",
      "To prevent injury",
      "To confuse others"
    ],
    answer: "To prevent injury"
  },
  {
    question: "Aesthetic value in art refers to:",
    options: [
      "Its market price",
      "Its size",
      "Its beauty and appeal",
      "Its weight"
    ],
    answer: "Its beauty and appeal"
  },
  {
    question: "Which of these shows rhythm in visual art?",
    options: [
      "Repeating shapes or colors",
      "Only using red",
      "Random placement",
      "Using one dot"
    ],
    answer: "Repeating shapes or colors"
  },
  {
    question: "Which of these is a benefit of group art projects?",
    options: [
      "Discourages sharing",
      "Reduces cooperation",
      "Promotes teamwork and creativity",
      "Limits imagination"
    ],
    answer: "Promotes teamwork and creativity"
  },
  {
    question: "Which of the following is used in collage making?",
    options: [
      "Leaves, cloth, and glue",
      "Only paint",
      "Only thread",
      "Metal rods"
    ],
    answer: "Leaves, cloth, and glue"
  },
  {
    question: "In drama, the script provides:",
    options: [
      "Only lighting instructions",
      "Costume details only",
      "Dialogue and action directions",
      "Sound effects list"
    ],
    answer: "Dialogue and action directions"
  },
  {
    question: "The art technique of decorating fabric using melted wax and dye is:",
    options: [
      "Crocheting",
      "Batik",
      "Sewing",
      "Casting"
    ],
    answer: "Batik"
  },
  {
    question: "The key responsibility of a director in a performance is to:",
    options: [
      "Sell tickets",
      "Paint the background",
      "Guide the overall production",
      "Play all instruments"
    ],
    answer: "Guide the overall production"
  },
  {
    question: "Which color is a primary color?",
    options: [
      "Green",
      "Purple",
      "Yellow",
      "Orange"
    ],
    answer: "Yellow"
  },
  {
    question: "Which of these best describes unity in design?",
    options: [
      "Mixing unrelated ideas",
      "Using only one color",
      "Creating harmony among all parts",
      "Adding confusion"
    ],
    answer: "Creating harmony among all parts"
  },
  {
    question: "What is the function of props in a play?",
    options: [
      "Provide background music",
      "Decorate costumes",
      "Support storytelling with objects",
      "Replace dialogue"
    ],
    answer: "Support storytelling with objects"
  },
  {
    question: "Which of these shows good audience behavior during a show?",
    options: [
      "Using phone loudly",
      "Cheering in the middle of a scene",
      "Remaining attentive and quiet",
      "Interrupting dialogue"
    ],
    answer: "Remaining attentive and quiet"
  },
  {
    question: "Which art activity encourages storytelling through movement?",
    options: [
      "Singing",
      "Dancing",
      "Drawing",
      "Weaving"
    ],
    answer: "Dancing"
  },
  {
    question: "A traditional Ghanaian drum used in festivals is:",
    options: [
      "Djembe",
      "Piano",
      "Xylophone",
      "Guitar"
    ],
    answer: "Djembe"
  },
  {
    question: "The planning stage of art creation is called:",
    options: [
      "Execution",
      "Framing",
      "Sketching or designing",
      "Polishing"
    ],
    answer: "Sketching or designing"
  },
  {
    question: "Which of these is a line direction in drawing?",
    options: [
      "Wet",
      "Zigzag",
      "Hard",
      "Light"
    ],
    answer: "Zigzag"
  },
  {
    question: "Which sense is most used in visual art?",
    options: [
      "Touch",
      "Taste",
      "Sight",
      "Hearing"
    ],
    answer: "Sight"
  },
  {
    question: "The texture in an artwork refers to:",
    options: [
      "The type of paint",
      "How the surface feels or looks",
      "The size of the canvas",
      "The color used"
    ],
    answer: "How the surface feels or looks"
  },
  {
    question: "Which element of music shows speed?",
    options: [
      "Pitch",
      "Tempo",
      "Harmony",
      "Tone"
    ],
    answer: "Tempo"
  },
  {
    question: "Which of these materials is used for tie-dye?",
    options: [
      "Clay",
      "Charcoal",
      "Fabric",
      "Metal"
    ],
    answer: "Fabric"
  },
  {
    question: "Which of these helps in observing safety in the dance studio?",
    options: [
      "Wearing heavy boots",
      "Stretching before dancing",
      "Dancing with sharp tools",
      "Eating while dancing"
    ],
    answer: "Stretching before dancing"
  },
  {
    question: "Which is a characteristic of a good storyteller?",
    options: [
      "Monotonous tone",
      "Lack of gestures",
      "Clear expression",
      "Facing away from audience"
    ],
    answer: "Clear expression"
  },
  {
    question: "What is the primary use of color in design?",
    options: [
      "To make art expensive",
      "To show size",
      "To create mood and meaning",
      "To create noise"
    ],
    answer: "To create mood and meaning"
  },
  {
    question: "What do we call a series of beats in music?",
    options: [
      "Tempo",
      "Rhythm",
      "Harmony",
      "Pitch"
    ],
    answer: "Rhythm"
  },
  {
    question: "Which of the following is a warm color?",
    options: [
      "Blue",
      "Purple",
      "Green",
      "Red"
    ],
    answer: "Red"
  },
  {
    question: "Which of these is an important role in stage performance?",
    options: [
      "Stage manager",
      "Photographer",
      "Tailor",
      "Cashier"
    ],
    answer: "Stage manager"
  },
  {
    question: "Which of the following is used in traditional Adinkra printing?",
    options: [
      "Stamp and dye",
      "Charcoal and chalk",
      "Brush and acrylic",
      "Pen and ink"
    ],
    answer: "Stamp and dye"
  },
  {
    question: "In drama, a dialogue is:",
    options: [
      "A costume",
      "Lighting effect",
      "Conversation between characters",
      "Dance movement"
    ],
    answer: "Conversation between characters"
  },
  {
    question: "Which of the following is used in making a puppet?",
    options: [
      "Battery",
      "Paper, cloth, and string",
      "Gum and oil",
      "Metal sheet"
    ],
    answer: "Paper, cloth, and string"
  },
  {
    question: "What is the main role of the audience during a performance?",
    options: [
      "Perform with the actors",
      "Direct the play",
      "Observe and respond",
      "Handle props"
    ],
    answer: "Observe and respond"
  },
  {
    question: "Which of these is not a color?",
    options: [
      "Green",
      "Large",
      "Blue",
      "Yellow"
    ],
    answer: "Large"
  },
  {
    question: "Which material is commonly used in model making?",
    options: [
      "Stone",
      "Cardboard",
      "Water",
      "Salt"
    ],
    answer: "Cardboard"
  },
  {
    question: "What is a silhouette in visual art?",
    options: [
      "A colored painting",
      "A drawing of eyes",
      "A dark shape outline of an object",
      "A mixed media design"
    ],
    answer: "A dark shape outline of an object"
  },
  {
    question: "Which of the following is an advantage of group performance?",
    options: [
      "Creates confusion",
      "Promotes cooperation",
      "Reduces creativity",
      "Limits participation"
    ],
    answer: "Promotes cooperation"
  },
  {
    question: "Which of these activities is part of stage design?",
    options: [
      "Learning lines",
      "Creating background scenery",
      "Practicing dance",
      "Singing in group"
    ],
    answer: "Creating background scenery"
  },
  {
    question: "A composition in art means:",
    options: [
      "Just one object",
      "Arrangement of elements in artwork",
      "A musical score",
      "A dance performance"
    ],
    answer: "Arrangement of elements in artwork"
  },
  {
    question: "A painting made on wet plaster is called:",
    options: [
      "Mural",
      "Fresco",
      "Oil painting",
      "Sketch"
    ],
    answer: "Fresco"
  },
  {
    question: "Which of these describes a low pitch sound?",
    options: [
      "Thin and high",
      "Soft and squeaky",
      "Deep and heavy",
      "Light and fast"
    ],
    answer: "Deep and heavy"
  },
  {
    question: "The purpose of rehearsals is to:",
    options: [
      "Waste time",
      "Confuse actors",
      "Practice before performance",
      "Disorganize the script"
    ],
    answer: "Practice before performance"
  },
  {
    question: "Which of these best describes a tone in music?",
    options: [
      "Color shade",
      "A single sound with pitch",
      "Lighting level",
      "A speech"
    ],
    answer: "A single sound with pitch"
  },
  {
    question: "A printing technique using carved wood and ink is:",
    options: [
      "Digital printing",
      "Screen printing",
      "Block printing",
      "Photo printing"
    ],
    answer: "Block printing"
  },
  {
    question: "What is the function of costume in drama?",
    options: [
      "Cover the stage",
      "Provide comfort only",
      "Show character and setting",
      "Make people laugh"
    ],
    answer: "Show character and setting"
  },
  {
    question: "Which of these helps protect the eyes when using sharp tools?",
    options: [
      "Gloves",
      "Goggles",
      "Apron",
      "Helmet"
    ],
    answer: "Goggles"
  },
  {
    question: "A sequence of steps in a dance is called:",
    options: [
      "Design",
      "Script",
      "Routine",
      "Verse"
    ],
    answer: "Routine"
  },
  {
    question: "Which of these encourages creativity in art?",
    options: [
      "Copying always",
      "Using same method every time",
      "Experimenting with new ideas",
      "Avoiding colors"
    ],
    answer: "Experimenting with new ideas"
  },
  {
    question: "Which of the following is a two-dimensional art?",
    options: [
      "Collage",
      "Pottery",
      "Sculpture",
      "Basket"
    ],
    answer: "Collage"
  },
  {
    question: "In dance, balance refers to:",
    options: [
      "Standing on one foot only",
      "Not moving at all",
      "Control of body position",
      "Jumping always"
    ],
    answer: "Control of body position"
  },
  {
    question: "Which art tool is used for measuring straight lines?",
    options: [
      "Brush",
      "Chisel",
      "Ruler",
      "Needle"
    ],
    answer: "Ruler"
  },
  {
    question: "Which of these is created using coils of clay?",
    options: [
      "Drawing",
      "Sculpture",
      "Collage",
      "Basket"
    ],
    answer: "Sculpture"
  },
  {
    question: "Which of the following best describes unity in dance?",
    options: [
      "Everyone dancing differently",
      "No timing at all",
      "Coordinated group movement",
      "Solo dancing"
    ],
    answer: "Coordinated group movement"
  },
  {
    question: "What do we call a drawing made using dots?",
    options: [
      "Hatching",
      "Crosshatching",
      "Stippling",
      "Smudging"
    ],
    answer: "Stippling"
  },
  {
    question: "Which of these best shows expression in music?",
    options: [
      "Playing very fast only",
      "Repeating notes",
      "Varying loudness and tone",
      "Skipping melody"
    ],
    answer: "Varying loudness and tone"
  },
  {
    question: "Which of the following describes abstract art?",
    options: [
      "Shows real-life objects clearly",
      "Only black and white",
      "Uses shapes and colors to express ideas",
      "Cartoon characters"
    ],
    answer: "Uses shapes and colors to express ideas"
  },
  {
    question: "Which of these is not a function of art?",
    options: [
      "Decoration",
      "Communication",
      "Confusion",
      "Education"
    ],
    answer: "Confusion"
  },
  {
    question: "A traditional Ghanaian festival performance often includes:",
    options: [
      "Silence",
      "Folk music and dance",
      "Modern painting",
      "Cartoon drawing"
    ],
    answer: "Folk music and dance"
  },
  {
    question: "Which of these is a technique in sculpture?",
    options: [
      "Casting",
      "Weaving",
      "Knitting",
      "Collaging"
    ],
    answer: "Casting"
  },
  {
    question: "Which of these encourages originality in art?",
    options: [
      "Tracing every image",
      "Repeating one idea",
      "Creating from personal ideas",
      "Ignoring imagination"
    ],
    answer: "Creating from personal ideas"
  },
  {
    question: "A short play with a lesson is called:",
    options: [
      "A poem",
      "A drama",
      "A skit",
      "A painting"
    ],
    answer: "A skit"
  },
  {
    question: "Which of these is used to blend colors in drawing?",
    options: [
      "Scissors",
      "Tissue or finger",
      "Chisel",
      "Blade"
    ],
    answer: "Tissue or finger"
  },
  {
    question: "Which of the following is a percussion instrument?",
    options: [
      "Flute",
      "Drum",
      "Violin",
      "Piano"
    ],
    answer: "Drum"
  },
  {
    question: "Which of these describes harmony in music?",
    options: [
      "A single note",
      "A melody played alone",
      "Different notes played together",
      "Fast tempo only"
    ],
    answer: "Different notes played together"
  },
  {
    question: "Which tool is used for sewing?",
    options: [
      "Brush",
      "Needle",
      "Ruler",
      "Palette"
    ],
    answer: "Needle"
  },
  {
    question: "Which of the following is an element of dance?",
    options: [
      "Stage light",
      "Sound system",
      "Movement",
      "Poster"
    ],
    answer: "Movement"
  },
  {
    question: "Which of the following is used to apply paint in art?",
    options: [
      "Fork",
      "Brush",
      "Knife",
      "Ruler"
    ],
    answer: "Brush"
  },
  {
    question: "In art, overlapping shapes can create a sense of:",
    options: [
      "Texture",
      "Depth",
      "Color",
      "Tone"
    ],
    answer: "Depth"
  },
  {
    question: "Which of the following is not a stage in the design process?",
    options: [
      "Planning",
      "Research",
      "Evaluation",
      "Sleeping"
    ],
    answer: "Sleeping"
  },
  {
    question: "Which of these is a form of textile design?",
    options: [
      "Photography",
      "Tie-dye",
      "Pottery",
      "Painting"
    ],
    answer: "Tie-dye"
  },
  {
    question: "What is a storyboard used for?",
    options: [
      "Cutting paper",
      "Planning scenes in a story or film",
      "Writing music",
      "Acting on stage"
    ],
    answer: "Planning scenes in a story or film"
  },
  {
    question: "A drawing made to prepare for a painting is called a:",
    options: [
      "Model",
      "Sketch",
      "Script",
      "Template"
    ],
    answer: "Sketch"
  },
  {
    question: "Which of these is a traditional Ghanaian musical instrument?",
    options: [
      "Kora",
      "Talking drum",
      "Violin",
      "Piano"
    ],
    answer: "Talking drum"
  },
  {
    question: "Which of the following is a creative way to recycle materials in art?",
    options: [
      "Throwing them away",
      "Burning them",
      "Making collage or sculpture",
      "Burying them"
    ],
    answer: "Making collage or sculpture"
  },
  {
    question: "Which of these is important in costume design?",
    options: [
      "Color and function",
      "Stage direction",
      "Volume",
      "Sound"
    ],
    answer: "Color and function"
  },
  {
    question: "Which of these is a theme often used in African storytelling?",
    options: [
      "Space travel",
      "Morals and values",
      "Robots",
      "Superpowers"
    ],
    answer: "Morals and values"
  },
  {
    question: "What is the name of the tool used to mix colors in painting?",
    options: [
      "Brush",
      "Palette",
      "Ruler",
      "Compass"
    ],
    answer: "Palette"
  },
  {
    question: "Which of the following is not a printmaking method?",
    options: [
      "Etching",
      "Screen printing",
      "Sculpting",
      "Block printing"
    ],
    answer: "Sculpting"
  },
  {
    question: "In music, a repeated pattern is called a:",
    options: [
      "Bridge",
      "Verse",
      "Refrain",
      "Ostinato"
    ],
    answer: "Ostinato"
  },
  {
    question: "Which of these helps create drama in a play?",
    options: [
      "Flat emotions",
      "Conflict and resolution",
      "Unclear plot",
      "One-word sentences"
    ],
    answer: "Conflict and resolution"
  },
  {
    question: "Which of these shows good audience behavior?",
    options: [
      "Shouting during performance",
      "Silently watching and clapping",
      "Throwing objects",
      "Using phone loudly"
    ],
    answer: "Silently watching and clapping"
  },
  {
    question: "A person who creates dances is called a:",
    options: [
      "Director",
      "Choreographer",
      "Singer",
      "Playwright"
    ],
    answer: "Choreographer"
  },
  {
    question: "What is line used for in visual art?",
    options: [
      "Only coloring",
      "Defining shapes and direction",
      "Creating sound",
      "Making food"
    ],
    answer: "Defining shapes and direction"
  },
  {
    question: "What does a logo represent?",
    options: [
      "A country",
      "An organization or brand",
      "A costume",
      "A festival"
    ],
    answer: "An organization or brand"
  },
  {
    question: "Which of these activities can be done in a drama class?",
    options: [
      "Cooking",
      "Role play",
      "Swimming",
      "Jumping rope"
    ],
    answer: "Role play"
  },
  {
    question: "Which of these is an appropriate safety rule in the art room?",
    options: [
      "Run with scissors",
      "Keep tools in proper place",
      "Ignore instructions",
      "Use paints on your clothes"
    ],
    answer: "Keep tools in proper place"
  },
  {
    question: "Which material is mostly used for sculpture?",
    options: [
      "Water",
      "Clay",
      "Wool",
      "Paper"
    ],
    answer: "Clay"
  },
  {
    question: "In acting, improvisation means:",
    options: [
      "Memorizing a script",
      "Performing without preparation",
      "Changing costume",
      "Singing a song"
    ],
    answer: "Performing without preparation"
  },
  {
    question: "Which of these helps artists show emotion in artwork?",
    options: [
      "Food",
      "Lines and colors",
      "Maths",
      "Metal tools"
    ],
    answer: "Lines and colors"
  },
  {
    question: "The area around and between objects in art is called:",
    options: [
      "Pattern",
      "Form",
      "Space",
      "Value"
    ],
    answer: "Space"
  },
  {
    question: "Which of the following is a fast dance from Ghana?",
    options: [
      "Adowa",
      "Agbadza",
      "Borborbor",
      "Kpanlogo"
    ],
    answer: "Kpanlogo"
  },
  {
    question: "What is the role of a director in theatre?",
    options: [
      "Paint scenery",
      "Lead the music",
      "Guide the overall production",
      "Play the lead role"
    ],
    answer: "Guide the overall production"
  },
  {
    question: "A drawing showing the front view of a house is called a:",
    options: [
      "Sketch",
      "Plan",
      "Elevation",
      "Cartoon"
    ],
    answer: "Elevation"
  },
  {
    question: "Which of the following is a traditional African dance style?",
    options: [
      "Ballet",
      "Hip-hop",
      "Highlife",
      "Adowa"
    ],
    answer: "Adowa"
  },
  {
    question: "A symbol used in Ghanaian culture for wisdom is:",
    options: [
      "Duafe",
      "Eban",
      "Eban",
      "Eban"
    ],
    answer: "Duafe"
  },
  {
    question: "Which of the following best describes choreography?",
    options: [
      "A musical tune",
      "The design of dance movements",
      "An artwork",
      "A costume piece"
    ],
    answer: "The design of dance movements"
  },
  {
    question: "Which element of design helps show contrast?",
    options: [
      "Texture",
      "Tone",
      "Color",
      "Shape"
    ],
    answer: "Tone"
  },
  {
    question: "In music, loudness or softness is called:",
    options: [
      "Pitch",
      "Melody",
      "Dynamics",
      "Tempo"
    ],
    answer: "Dynamics"
  },
  {
    question: "Which of these instruments has strings?",
    options: [
      "Flute",
      "Xylophone",
      "Guitar",
      "Drum"
    ],
    answer: "Guitar"
  },
  {
    question: "A traditional dance performed during festivals is:",
    options: [
      "Ballet",
      "Kete",
      "Waltz",
      "Breakdance"
    ],
    answer: "Kete"
  },
  {
    question: "What is a graphic design?",
    options: [
      "Stage light",
      "2D visual communication using text and image",
      "Dance form",
      "Drum beat"
    ],
    answer: "2D visual communication using text and image"
  },
  {
    question: "Which of these is used in making mosaic art?",
    options: [
      "Leaves",
      "Broken tiles or paper",
      "Oil paint",
      "Water"
    ],
    answer: "Broken tiles or paper"
  },
  {
    question: "Which of the following helps develop rhythm?",
    options: [
      "Jumping rope",
      "Clapping and stepping",
      "Reading books",
      "Eating"
    ],
    answer: "Clapping and stepping"
  },
  {
    question: "Which of these tools is used for carving?",
    options: [
      "Needle",
      "Chisel",
      "Brush",
      "Pencil"
    ],
    answer: "Chisel"
  },
  {
    question: "A person who writes scripts for plays is a:",
    options: [
      "Choreographer",
      "Scriptwriter",
      "Singer",
      "Painter"
    ],
    answer: "Scriptwriter"
  },
  {
    question: "The study of color combinations in design is called:",
    options: [
      "Form theory",
      "Tone drawing",
      "Color theory",
      "Object study"
    ],
    answer: "Color theory"
  },
  {
    question: "Which of the following is a mask used for?",
    options: [
      "Protection only",
      "Decoration and performance",
      "Eating",
      "Washing"
    ],
    answer: "Decoration and performance"
  },
  {
    question: "Which of these is a type of art done on walls?",
    options: [
      "Mural",
      "Sketch",
      "Poster",
      "Logo"
    ],
    answer: "Mural"
  },
  {
    question: "What is puppetry?",
    options: [
      "Dancing in costume",
      "Using figures to perform",
      "Singing alone",
      "Painting faces"
    ],
    answer: "Using figures to perform"
  },
  {
    question: "Which is an example of a cool color?",
    options: [
      "Red",
      "Orange",
      "Blue",
      "Yellow"
    ],
    answer: "Blue"
  },
  {
    question: "In storytelling, what does the climax mean?",
    options: [
      "The beginning",
      "The peak or most intense part",
      "The end",
      "The title"
    ],
    answer: "The peak or most intense part"
  },
  {
    question: "Which of these is important in stage lighting?",
    options: [
      "Brightness and color",
      "Loudness",
      "Clarity",
      "Temperature"
    ],
    answer: "Brightness and color"
  },
  {
    question: "What is a sculpture?",
    options: [
      "A flat picture",
      "A 3D art object",
      "A musical note",
      "A dance"
    ],
    answer: "A 3D art object"
  },
  {
    question: "Which of the following helps express emotions in dance?",
    options: [
      "Costume only",
      "Movement and gesture",
      "Poster",
      "Props"
    ],
    answer: "Movement and gesture"
  },
  {
    question: "Which material is commonly used in raffia weaving?",
    options: ["Wool", "Cotton", "Plastic", "Dried palm leaves"],
    answer: "Dried palm leaves"
  },
  {
    question: "What is the first step in basket weaving?",
    options: ["Painting the base", "Cutting the basket", "Preparing the materials", "Adding decorations"],
    answer: "Preparing the materials"
  },
  {
    question: "Which of the following tools is used in pottery?",
    options: ["Trowel", "Loop tool", "Scissors", "Ruler"],
    answer: "Loop tool"
  },
  {
    question: "What is the purpose of firing clay in a kiln?",
    options: ["To melt the clay", "To dry the water", "To harden and finish the work", "To change its color"],
    answer: "To harden and finish the work"
  },
  {
    question: "Why is branding important in selling creative products?",
    options: ["To hide the price", "To confuse customers", "To attract and inform buyers", "To avoid taxes"],
    answer: "To attract and inform buyers"
  },
  {
    question: "Which of these is a way an artist can earn income?",
    options: ["Borrowing art", "Donating all art", "Selling artwork", "Only creating for fun"],
    answer: "Selling artwork"
  },
  {
    question: "Which software can be used for creating digital drawings?",
    options: ["Microsoft Word", "Adobe Illustrator", "Google Chrome", "Excel"],
    answer: "Adobe Illustrator"
  },
  {
    question: "What is an advantage of digital art over traditional art?",
    options: ["It uses more paper", "It cannot be shared", "It allows easy editing and storage", "It is slower"],
    answer: "It allows easy editing and storage"
  },
  {
    question: "Which question is most useful when analyzing an artwork?",
    options: ["How expensive is it?", "What emotions does it show?", "What is the artist's age?", "Where was it painted?"],
    answer: "What emotions does it show?"
  },
  {
    question: "What is art criticism?",
    options: ["Judging people", "Cleaning paintings", "Evaluating and interpreting artworks", "Memorizing artist names"],
    answer: "Evaluating and interpreting artworks"
  },
  {
    question: "Which is the safest way to handle sharp art tools?",
    options: ["Wave them in the air", "Keep them on the floor", "Store properly after use", "Lend them to anyone"],
    answer: "Store properly after use"
  },
  {
    question: "Why should you wash your hands after using paints?",
    options: ["To play with water", "To avoid stains and chemical exposure", "To waste time", "To dry them quickly"],
    answer: "To avoid stains and chemical exposure"
  },
  {
    question: "What is the main purpose of using recycled materials in art?",
    options: ["To increase waste", "To reduce costs and protect the environment", "To make work easier", "To copy others"],
    answer: "To reduce costs and protect the environment"
  },
  {
    question: "Which of the following is a recyclable item for artwork?",
    options: ["Fresh vegetables", "Broken glass", "Plastic bottles", "Live animals"],
    answer: "Plastic bottles"
  },
  {
    question: "Which science concept helps in understanding color mixing?",
    options: ["Gravity", "Photosynthesis", "Light and pigments", "Evaporation"],
    answer: "Light and pigments"
  },
  {
    question: "What natural dye source can be used in textile work?",
    options: ["Plastic", "Petrol", "Leaves and roots", "Metal cans"],
    answer: "Leaves and roots"
  },
  {
    question: "Why is imagination important in creating art?",
    options: ["To follow instructions only", "To copy others", "To create unique and personal works", "To make no mistakes"],
    answer: "To create unique and personal works"
  },
  {
    question: "What can help improve an artwork after feedback?",
    options: ["Ignoring it", "Repeating the same thing", "Making no changes", "Making thoughtful revisions"],
    answer: "Making thoughtful revisions"
  },
  {
    question: "What is the benefit of entrepreneurship education in art?",
    options: ["To avoid business", "To memorize art history", "To create and sell original works", "To stop learning"],
    answer: "To create and sell original works"
  },
  {
    question: "Which digital device is used to capture images for digital art projects?",
    options: ["Flashlight", "Printer", "Scanner", "Keyboard"],
    answer: "Scanner"
  }
];
export default jhscreativeArtsAndDesignQuestions;